import { apiClient } from "../config";

async function createLayer(communityId:string,payload: any) {
  const res = await apiClient.post(`/admin/communities/${communityId}/geography`,payload);
  return res.data;
}

export default createLayer;
